module.exports = __webpack_public_path__ + "static/img/w2.9186a63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/challenge/w2.png
// module id = T1Lc
// module chunks = 1